export default __webpack_public_path__ + "static/media/ally_said_babu.593cab86.m4a";